<template>
  <div
    class
    style="position:relative; display:block; overflow:hidden; height:100%; margin-top:0px !important;"
  >
    <div
      style="position:relative; height:100%;"
      class="d-flex align-items-center justify-content-center"
    >
      <div id="wrap_selettore_ricambi" class="d-flex h-100 w-100" style="flex-direction:column;">
        <div
          class="d-flex align-items-center"
          style="height:4vh; margin-bottom:1.5vh; margin-left:2vh; margin-right:2vh; padding-left:1vw; -webkit-border-radius: 10px;
-moz-border-radius: 10px;
border-radius: 10px; background-color:white;"
        >
          <div class="d-flex" v-if="showBreadCrumbs===true">
            <i
              @click="selettoreIndietro()"
              @keyup.enter="selettoreIndietro()"
              class="tasto_back fas fa-arrow-circle-left"
            ></i>

            <div style="margin-left:1vw;">
              <ol v-if="cronologia_selettore.length " class="breadcrumb">
                <li
                  :key="step.id"
                  @click="caricaBreadcrumb(step,index)"
                  v-for="(step,index) in cronologia_selettore"
                  class="breadcrumb-item capitalized"
                >
                  <span>{{step.value}}</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div
          id="div_selettore"
          v-on:scroll="handleScrollSelettore()"
          class="container m-0 p-0 zona_scroll_selettore"
        >
          <VuePerfectScrollbar
            id="PerfectScroll"
            class="scroll-area-selettore"
            :settings="settings"
            @ps-scroll-y="scrollHanle"
          >
            <img
              class="spinner_loading"
              v-if="!selettore.stato_caricamento"
              src="../images/ordine/spinner_loading.gif"
            />
            <ul class="list_selettore">
              <li
                :id="idDinamico(ricambio.id)"
                :class="{'ultimo_inserito' : ricambio.id === appena_salvato, 'evidenzia' : selettore.mantieniAggiuntivo === ricambio.id, 'opaco' : nelCarrello(ricambio)}"
                class="tabable sele bordo_animato"
                v-bind:tabindex="(index===selettore.focus) ? 3 : ''"
                @keydown="freccieTastiera('selettore', $event)"
                v-for="(ricambio,index) in ricambi "
                :key="ricambio.id"
                @keydown.enter.stop="ricambio['parent'] !== 'ricambi' ? (caricaStep(ricambio),pushSelettore(ricambio)) : null"
                @click="itemClicked(ricambio),ricambio['parent'] !== 'ricambi' ? (caricaStep(ricambio),pushSelettore(ricambio)) : null"
              >
                <div
                  @click.stop="funzioneAggiuntiva(ricambio)"
                  v-if="selettore.tastoAggiuntivo && (!selettore.mantieniAggiuntivo || selettore.mantieniAggiuntivo === ricambio.id)"
                  :class="{ mantieni : selettore.mantieniAggiuntivo === ricambio.id || ricambio.regola_specifica === true}"
                  class="tasto_aggiuntivo_quadratino"
                >
                  <i v-if="!ricambio.regola_specifica" class="fas fa-plus"></i>
                  <i v-if="ricambio.regola_specifica" class="fas fa-minus"></i>
                </div>
                {{ spegniUltimo(ricambio.id) }}
                <div class="caption">
                  <div v-if="selettore.mostra_pulsantini" class="pulsantini">
                    <i
                      class="fas fa-pencil-alt"
                      v-if="inEdit.title ==='' && ricambio.fonte === 'interno' "
                      title="edit"
                      @click.stop="inEdit.title= ricambio.id,inEdit.value=ricambio.value"
                    ></i> &nbsp;
                    <i
                      class="fas fa-undo-alt"
                      v-if="inEdit.title === ricambio.id"
                      title="annulla"
                      @click.stop="inEdit.title = '',inEdit.value=''"
                    ></i> &nbsp;
                    <i
                      class="fas fa-save"
                      title="salva"
                      v-if="inEdit.title === ricambio.id"
                      @click.stop="inEdit.title= '',creaAlias(ricambio,inEdit.value)"
                    ></i>&nbsp;
                    <i class="fas fa-trash"></i>
                  </div>

                  <span
                    v-if="selettore.mostra_sconto && ricambio.l_prezzo"
                    class="tag_prezzo tag_prezzo"
                  >{{ ricambio.l_prezzo }} €</span>

                  <span
                    v-if="ricambio.prezzo>0 && selettore.mostra_prezzo && ricambio.parent === 'ricambi'"
                    class="tag_prezzo tag_prezzo"
                  >{{ calcolaPrezzo(ricambio) }}</span>
                </div>

                <div
                  @keyup.enter="!nelCarrello(ricambio) ? addToCart(ricambio) : removeFromCart(ricambio)"
                  class="d-flex justify-content-center no-focus"
                  v-on:click="!nelCarrello(ricambio) ? addToCart(ricambio) : removeFromCart(ricambio), quadratino_selezionato = index,selettore.step_selezionato = ricambio, ricambio.parent==='ricambi' ? cambiaSelezione('selettore', index) : null"
                >
                  <!--<div v-if="nelCarrello(ricambio)" class="aggiunto">
                    <img src="../images/checked.png">
                  </div>-->

                  <div class="d-flex align-items-center" style="height:calc(100% - 2.2vh);">
                    <div style="position:relative;">
                      <imageLoader :imgInfo="ricambio" style=" margin:0 auto; display:block;"></imageLoader>
                      <!-- C'ERA QUESTO IF CHE NON CAPISCO COSA FACCIA NEL DIV SOTTOSTANTEv-if="1"-->
                      <div
                        v-if="inEdit.title !== ricambio.id "
                        class="titolo_ricambio"
                      >{{ ricambio['value'] }}</div>
                      <input
                        class="titolo_ricambio"
                        @keyup.enter="creaAlias(ricambio,inEdit.value)"
                        @click.stop
                        v-if="inEdit.title === ricambio.id"
                        v-model="inEdit.value"
                      />
                    </div>
                  </div>
                </div>
              </li>
              <li
                v-on:click="tastoPiu()"
                :class="{blink_me : inserimento_in_corso, form_cartella : inserimento_cartella, pieno : !inserimento_cartella}"
                class="tabable sele"
                v-if="selettore.stato_caricamento && selettore.tastoPiu"
              >
                <div
                  v-if="!inserimento_cartella"
                  class="h-100 w-100 d-flex align-items-center justify-content-center"
                >
                  <div class="tasto_add_ricambio fas fa-plus"></div>
                </div>

                <div v-if="inserimento_cartella" class="caption">
                  <div class="pulsantini">
                    <i class="fas fa-pencil-alt"></i> &nbsp;
                    <i class="fas fa-trash"></i>
                  </div>
                </div>

                <div
                  v-if="inserimento_cartella"
                  class="d-flex align-items-center justify-content-center"
                  style="height:calc(100% - 2.2vh);"
                >
                  <div
                    class="d-flex align-items-center justify-content-center"
                    style="position:relative; flex-direction:column;"
                  >
                    <label
                      v-if="!avatar"
                      for="file_upload"
                      class="load_img d-flex align-items-center"
                    >
                      <div v-if="carico_immagine" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <i
                        v-if="!avatar && !carico_immagine"
                        class="fas fa-camera-retro"
                        style="margin:0 auto; display:block;"
                      ></i>
                      <input
                        id="file_upload"
                        type="file"
                        style="display:none;"
                        @change="listaImmagini($event.target.files)"
                      />
                    </label>
                    <img class="avatar m-auto" v-if="avatar" :src="avatar" />
                    <input
                      v-model="nome_cartella"
                      id="titolo_cartella"
                      v-if="1"
                      placeholder="titolo"
                      class="input_titolo_cartella"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </VuePerfectScrollbar>
        </div>
        <transition name="fade">
          <div
            v-if="selettore.scroll"
            class="freccia_scroll_selettore"
            :class="{scrolling : selettore.scrolling_selettore}"
          >
            <i
              class="fas fa-angle-down"
              :class="{freccia_ruotata : selettore.fine_scrolling_selettore}"
            ></i>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fade">
      <div @click="clickSuOverlay()" v-if="showOverlay" class="overlay_mask"></div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { storage } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { faEuroSign } from "@fortawesome/fontawesome-free-solid";

export default {
  components: {
    VuePerfectScrollbar
  },
  props: ["selettore", "regole", "items"],
  name: "Selettore",
  data() {
    return {
      showOverlay: false,
      nome_cartella: "",
      carico_immagine: false,
      avatar: "", //l'IMMAGINE DELLA CARTELLA STO INSERENDO/MODIFICANDO
      chiave_inserimento: "", // KEY CHE GENERO PER L'INSERIMENTO, VIENE GENERATA QUI PER CONSENTIRE IL PRE-UPLOAD IMMAGINE
      inserimento_cartella: false,
      appena_salvato: "",
      inserimento_in_corso: false,
      //vedi pulsantini modifica/salva titolo quadratini.
      inEdit: {
        title: "",
        value: ""
      },
      settings: {
        maxScrollbarLength: 50,
        suppressScrollX: true
      },
      cronologia_selettore: [],
      ricambi: [],
      ganci_nuovo_elemento: {} //DOVE SALVO PARENT,HOOK E CATEGORY DELL'EVENTUALE ELEMENTO DA INSERIRE
    };
  },
  computed: {
    showBreadCrumbs() {
      if (
        this.cronologia_selettore != undefined &&
        this.cronologia_selettore.length > 1 &&
        this.selettore.showAlwaysBreadCrumbs != undefined
      ) {
        if (
          this.cronologia_selettore[this.cronologia_selettore.length - 1]
            .hook === "ricambi" &&
          this.selettore.showAlwaysBreadCrumbs === false
        ) {
          return false;
        } else return true;
      } else {
        return true;
      }
    },
    icon() {
      if (this.cronologia_selettore.length < 4) {
        return "\uf002  Cosa devi riparare?";
      } else {
        return "\uf002  Scegli i ricambi";
      }
    },
    percorso_cartelle() {
      //CONSIDERANDO CHE DI PER SE IL PERCORSO IN UN DB VUOTO NON PUO' ESSERE
      //RICOSTRUITO LO DEVO DICHIARARE DA QUALCHE PARTE E LO FACCIO COSI'
      let percorso = ["tipologie", "marche", "modelli"];
      //L'ULTIMO STEP PUO' ESSERE 'RICAMBI' O 'ACCESSORI
      //IN BASE ALL'ELEMENTO AL TAB CHE HO SELEZIONATO NELLA PAGINE CHE OSPITA IL SELETTORE (RICAMBI/ACCESSORI/ALTRO)
      //QUEST'ULTIMO ESSENDO VARIABILE VIENE PASSATO VIA PROPS
      let ultimo_step = this.selettore.ultimo_step;
      percorso.push(ultimo_step);
      return percorso;
    },
    marca_modello() {
      let posizione = this.cronologia_selettore.length;
      //CONTROLLO SE SONO NELL'ULTIMO STEP PATH SERVE SOLO NEL SALVATAGGIO RICAMBI/ACCESSORI/ALTRO
      if (
        this.percorso_cartelle[posizione - 1] === this.selettore.ultimo_step
      ) {
        let temp = [];
        //LEGGO LA MARCA
        temp[0] = this.cronologia_selettore[posizione - 2].value;
        //LEGGO IL MODELLO
        temp[1] = this.cronologia_selettore[posizione - 1].value;
        return temp;
      }
    },
    path() {
      let posizione = this.cronologia_selettore.length;
      //CONTROLLO (funzione disattivata) SE SONO NELL'ULTIMO STEP PATH SERVE SOLO NEL SALVATAGGIO RICAMBI/ACCESSORI/ALTRO
      // if (
      // this.percorso_cartelle[posizione - 1] === this.selettore.ultimo_step
      //) {
      let p = [];
      let t = {};
      let i;
      //CICLO LA CRONOLOGIA SELETTORE PER CREARE IL PATH
      for (i = 0; i < this.cronologia_selettore.length - 1; i++) {
        t = {};
        t[this.percorso_cartelle[i]] = this.cronologia_selettore[i + 1].id;
        p.push(t);
      }
      //A QUESTO PUNTO AL PATH MANCA SOLO L'GGETTO CHE VADO AD AGGIUNGERE
      //LO FACCIO DURANTE IL SALVATAGGIO IN QUANTO NON NE CONOSCO ANCORA L'ID
      return p;
      //}
    }
  },
  methods: {
    clickSuOverlay() {
      if (this.inserimento_cartella === true) {
        if (this.nome_cartella) {
          //LEGGO IL NOME DELLA CARTELLA IN CUI MI TROVO
          let posizione = this.cronologia_selettore.length;
          let cartella = this.cronologia_selettore[posizione - 1].hook;
          if (!this.chiave_inserimento) this.generaChiaveInserimento(cartella);
          let oggetto = { value: this.nome_cartella };
          this.SalvaNuovoElemento(oggetto, this.chiave_inserimento);
        }
        this.inserimento_cartella = false;
        this.selettore.lock_cambio_nodo = false;
        this.showOverlay = false;
      }
    },
    calcolaPrezzo(ricambio) {
      let risultato;
      risultato = parseFloat(ricambio.prezzo);
      if (risultato > 0) {
        if (ricambio.l_prezzo) risultato += parseFloat(ricambio.l_prezzo);
        return risultato + " €";
      } else return null;
    },
    applicaListino(regole) {
      //N.B Richiamo questa fx in caricaStep()
      var self = this;
      //this.rimuoviListino();
      if (Object.keys(this.ricambi).length > 0) {
        //PER OGNI RICAMBIO
        this.ricambi.forEach(function(ricambio, index) {
          var i = index;
          //SE ESISTE PATH
          if (ricambio.path !== undefined) {
            if (Object.keys(regole).length > 0) {
              //PER OGNI REGOLA
              regole.forEach(function(regola, index) {
                if (true) {
                  //PER OOGNI PATH DEL RICABIO
                  ricambio.path.forEach(function(path, index) {
                    if (path[regola.parent] !== undefined)
                      if (path[regola.parent] === regola.id) {
                        self.$set(self.ricambi[i], "l_prezzo", regola.l_prezzo);
                        if (
                          regola.id === ricambio.id &&
                          regola.l_prezzo != 0 &&
                          regola.l_prezzo != -0
                        ) {
                          self.$set(self.ricambi[i], "regola_specifica", true);
                        }
                        console.log("trovata regola compatibile");
                      }
                  });
                } else console.log("Regola più recente rispetto all attuale");
              });
            } else console.log("Nessuna regola nel listino");
          } else console.log("Path ricambio non definito");
        });
      } else console.log("Nessun ricambio al quale applicare listino");
    },
    rimuoviListino() {
      //elimina qualsiasi listino dall array ricambi/accessori
      //implementare fonte dell array da trattare
      this.ricambi.forEach(function(ricambio, index) {
        Object.keys(ricambio).forEach(function(key) {
          if (key.substring(0, 2) === "r_" || key.substring(0, 2) === "l_")
            Vue.delete(ricambio, key);
        });
      });
    },
    // Helper function to get an element's exact position
    getPosition(el) {
      var xPos = 0;
      var yPos = 0;
      while (el) {
        if (el.tagName == "BODY") {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;
          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }
        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos
      };
    },
    idDinamico(id) {
      return "el_" + id;
    },
    itemClicked(ricambio) {
      this.$emit("itemClicked", ricambio);
    },
    funzioneAggiuntiva(ricambio) {
      let key = ricambio.id;
      //LEGGO LA POSIZIONE DEL QUADRATINO NELLO SCHERMO
      let elemento = document.getElementById("el_" + key);
      var style = elemento.currentStyle || window.getComputedStyle(elemento);
      var posizione = this.getPosition(elemento);
      posizione.altezza = elemento.offsetHeight;
      posizione.larghezza = elemento.offsetWidth;
      var parametri = [posizione, ricambio];
      this.$emit("tastoAggiuntivo", parametri);
    },
    generaChiaveInserimento(cartella) {
      let self = this;
      let nodo = "Interno";
      //let scelta_tipo = "ricambi"; //QUESTO SARA' VARIABILE (A SECONDA DEL TAB SELEZIONATO)
      var refDestinazione = ref[nodo].child(cartella);
      var key = refDestinazione.push().key;
      this.chiave_inserimento = key;
    },
    listaImmagini(immagini) {
      //LEGGO IL NOME DELLA CARTELLA IN CUI MI TROVO
      let posizione = this.cronologia_selettore.length;
      let cartella = this.cronologia_selettore[posizione - 1].hook;
      alert(cartella);
      if (!this.chiave_inserimento) this.generaChiaveInserimento(cartella);
      this.immagini = immagini;
      //RICAMBI DEVE DIVENTARE VARIABILE A SECONDA DEL TAB SELEZIONATO RICAMBI ACCESSORI ETC.
      this.uploadImmagine(this.chiave_inserimento, this.immagini[0], cartella);
    },
    uploadImmagine(id_ricambio, file, cartella) {
      this.avatar = "";
      var self = this;
      // Assegno come nome immagine l'ID assegnato al nodo al quale appartiene l'img
      var metadata = {
        contentType: file.type,
        Software: "Jestionale"
      };
      //SISTEMARE QUI IL REF IMMAGINI
      if (this.selettore.nodo_inserimento === "Esterno")
        var refDestinazione = ref["StorageEsterno"].child(cartella);
      if (this.selettore.nodo_inserimento === "Interno")
        var refDestinazione = ref["StorageInterno"].child(cartella);
      var uploadTask = refDestinazione.child(id_ricambio).put(file, metadata);
      uploadTask.on(
        "state_changed", // or 'state_changed'
        function(snapshot) {
          self.carico_immagine = true;
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          self.statoLoadImg = snapshot.state + ":" + progress + "%";
          console.log("Upload is " + progress + "% done");
          if ((progress = 100)) {
            self.oggetto = {};
          }
          switch (snapshot.state) {
            case "paused": // or 'paused'
              console.log("Upload is paused");
              break;
            case "running": // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        function(error) {
          console.log(error);
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
            case "storage/unknown":
              break;
          }
        },
        function() {
          self.registraChunk(id_ricambio, cartella);
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.carico_immagine = false;
            console.log("File available at", downloadURL);
            self.avatar = downloadURL;
          });
        }
      );
    },
    registraChunk(key, percorso) {
      let oggetto_chunk = {};
      oggetto_chunk.percorso = percorso;
      oggetto_chunk.value = key;
      //sistemare regola firebase che previene sovrascrittura intero nodo ricambi
      ref["Chunk"].child(key).set(oggetto_chunk, function(error) {
        if (error) console.log("Errore salvataggio chunk");
        else {
        }
      });
    },
    deflaggaChunk(key) {
      ref["Chunk"].child(key).remove();
    },
    spegniUltimo(id) {
      let self = this;
      let delay = setTimeout(function() {
        self.appena_salvato = "";
      }, 3000);
    },
    chiediPrima() {
      let self = this;
      return new Promise((resolve, reject) => {
        if (!this.inserimento_in_corso) {
          resolve(true); // fulfilled
        } else
          self
            .$swal({
              title: "Stai inserendo un ricambio!",
              text: "Sei sicuro di voler abbandonare?",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Si, abbandona",
              cancelButtonText: "No!",
              showCloseButton: true,
              showLoaderOnConfirm: true
            })
            .then(result => {
              if (result.value) {
                resolve(true); // fulfilled
                self.inserimento_in_corso = false;
                self.selettore.lock_cambio_nodo = false;
                self.$emit("inserimentoAnnullato");
              } else {
                reject(false); // rejected
              }
            });
      });
    },
    //GESTISCE IL TASTO PIU
    tastoPiu() {
      let posizione = this.cronologia_selettore.length;
      let cartella_corrente = this.cronologia_selettore[posizione - 1].hook;
      //CONTROLLO SE MI TROVO NELL'ULTIMA CARTELLA, IN QUESTO CASO SARA' RICAMBI MA IL VALORE DOVRA' DIVENTARE VARIABILE
      //ES. RICAMBI-ACCESSORI-CELL_IN_VENDITA A SECONDA DEL TAB ATTIVO / VEDI PERCORSO_CARTELLE
      if (cartella_corrente === "ricambi") {
        this.$emit("tastoPiu", this.cronologia_selettore[posizione - 1]);
        this.inserimento_in_corso = true;
        this.selettore.lock_cambio_nodo = true;
      }
      if (cartella_corrente !== "ricambi") {
        this.inserimento_cartella = true;
        this.selettore.lock_cambio_nodo = true;
        Vue.nextTick(() => {
          this.showOverlay = true;
          titolo_cartella.focus();
        });
      }
    },
    //GENERA CATEOGRY E PARENT PER L'ELEMENTO DA AGGIUNGERE AL DB IN BASE A STEP CORRENTE
    CreaGanciNuovoElemento(step_corrente) {
      this.ganci_nuovo_elemento = {};
      // la CATEGORY del ricambio che andrò inserire corrisponde all'ID dello STEP CORRENTE
      this.ganci_nuovo_elemento.category = step_corrente.id;
      // la PARENT del ricambio che andrò inserire corrisponde all'hook dello STEP CORRENTE
      this.ganci_nuovo_elemento.parent = step_corrente.hook;
      //nei GANCI aggiungo anche il nome del MODELLO che verrà mostrato nel primo riquadro compatibilità del 'carrello'
      //HOOK SERVE SOLTANTO NELLA QUANDO L'ELEMENTO CHE STO CREANDO E'
      //UNA CARTELLA (RICAMBI E ACCESSORI NON HANNO HOOK)
      //ED E' BASTATO SULLA POSIZIONE DELLO STEP

      let posizione = this.cronologia_selettore.length;

      //CONTROLLO SE SONO NELL'ULTIMO STEP (L'HOOK LI NON SERVE)
      if (this.percorso_cartelle[posizione - 1] != this.selettore.ultimo_step)
        this.ganci_nuovo_elemento.hook = this.percorso_cartelle[posizione];
    },
    gestisciEventi(dettagliEvento) {
      let self = this;
      switch (dettagliEvento.evento) {
        case "salva":
          self.SalvaNuovoElemento(dettagliEvento.dati, dettagliEvento.chiave);
          break;
      }
    },
    SalvaNuovoElemento(elemento, key) {
      let self = this;
      let nodo;
      //SE NELLE SPECIFICHE DEL SELETTORE E' PRESENTE
      //NODO INSERIMENTO ALLORA LO PRENDO DA LI' ALTRIMENTI DI DEFAULT E' INTERNO.
      if (this.selettore.nodo_inserimento) {
        nodo = this.selettore.nodo_inserimento;
      } else {
        nodo = "Interno";
      }
      //LEGGO IL NOME DELLA CARTELLA IN CUI MI TROVO
      let posizione = this.cronologia_selettore.length;
      let cartella = this.cronologia_selettore[posizione - 1].hook;
      //let scelta_tipo = "ricambi"; //QUESTO LO POTRO LEGGERE DALLA POSIZIONE DEL SELETTORE.
      var refDestinazione = ref[nodo].child(cartella);
      elemento.value = elemento.value.toLowerCase();
      elemento.id = key;
      elemento.img_name = key;
      //elemento.parent = scelta_tipo;
      elemento.category = this.ganci_nuovo_elemento.category;
      elemento.parent = this.ganci_nuovo_elemento.parent;
      elemento.s1 = elemento.category + "/" + elemento.value;
      if (this.ganci_nuovo_elemento.hook) {
        elemento.hook = this.ganci_nuovo_elemento.hook;
      }
      if (this.path) {
        var temp_path = [];
        //CLONO PATH IN UNA VARIABILE INTERNA DISABILITANDO LA REATTIVITA'
        temp_path = JSON.parse(JSON.stringify(this.path));
        //DICHIARO L'ULTIMO ELEMENTO DA AGGIUNGERE AL PATH OVVERO QUELLO CHE STO SALVANDO
        let ultimo_elemento_path = {};
        //QUESTA RIGA E' DA EVOLVERE PERCHE' ALL'ULTIMO STEP
        //POTREI NON VOLER INSERIRE UN RICAMBIO MA AD ESEMPIO UN ACCESSORIO
        //E IN QUESTO CASO 'CARTELLA' CORRISPONDE ALL'HOOK DELLO STEP PRECEDENTE
        //COME DA NOTE IN MONDAY DOVREMMO FARE IN MODO CHE L' HOOK DI 'DISPOSITIVI' PUNTI A UNAz
        ultimo_elemento_path[cartella] = key;
        temp_path.push(ultimo_elemento_path);
        elemento.path = temp_path;
      }
      if (this.marca_modello) {
        elemento.marca = this.marca_modello[0];
        elemento.modello = this.marca_modello[1];
      }
      // QUESTO SERVE NEL CASO IN CUI STO SALVANDO UN ACCESSORIO
      //if (this.id_disp && this.id_cat_acc)
      //this.oggetto[this.id_disp] = this.id_cat_acc;
      /*MANCA HOOK (NEL CASO DEL RICAMBIO NON SERVE, E' IL LINK ALLO STEP SUCCESSIVO)
     COSTO*
     */
      elemento.fonte = nodo.toLowerCase();
      console.log(elemento);
      refDestinazione.child(key).set(elemento, function(error) {
        if (error) alert("error: " + error);
        else {
          self.chiave_inserimento = "";
          self.nome_cartella = "";
          self.avatar = false;
          self.immagini = "true";
          //EMETTO UN EVENTO DI SALVATAGGIO AVVENUTO CON SUCCESSO
          //IL PARENT PUO' VERIFICARE
          //SE LA CHIAVE L'HA PASSATA LUI, E NEL CASO LA RESETTA E AZZERA IL CARRELLO
          self.deflaggaChunk(key);
          self.$emit("salvato", key);
          self.inserimento_in_corso = false;
          self.selettore.lock_cambio_nodo = false;
          self.appena_salvato = key;
        }
      });
    },
    selettoreIndietro() {
      let self = this;
      this.chiediPrima().then(function() {
        var length = self.cronologia_selettore.length;
        if (length > 1) {
          self
            .caricaStep(
              self.cronologia_selettore[self.cronologia_selettore.length - 2]
            )
            .then(function(snapshot) {
              self.cronologia_selettore.splice(length - 1, 2);
            });
        }
      });
    },
    verificaScroll(selettore) {
      this[selettore].scroll = false;
      let self = this;
      clearTimeout(self[selettore].delay);
      self[selettore].delay = setTimeout(function() {
        //self.fine_scrolling_selettore = false;
        let scroll = document.getElementById(self[selettore].div_scroll)
          .scrollHeight;
        let altezza = document.getElementById(self[selettore].div_scroll)
          .clientHeight;
        if (scroll > altezza) {
          self[selettore].scroll = true;
        } else {
          self[selettore].scroll = false;
        }
      }, 500);
    },
    scrollHanle(evt) {
      this.selettore.scrolling_selettore = true;
      let self = this;
      clearTimeout(self.selettore.scrolling_delay);
      self.selettore.scrolling_delay = setTimeout(function() {
        self.selettore.scrolling_selettore = false;
      }, 100);
      let scroll = div_selettore.scrollTop;
      let posizione_scroll = div_selettore.clientHeight + scroll;
      //let altezza_scroll = div_selettore.scrollHeight;
      if (posizione_scroll >= altezza_scroll) {
        this.selettore.fine_scrolling_selettore = true;
      } else {
        this.selettore.fine_scrolling_selettore = false;
      }
    },
    handleScrollSelettore(event) {},
    ricerca(value) {
      let self = this;
      this.ricambi = [];
      //se mi trovo in X cerco in A,B,C
      /*per ora non è possibile cercare i ricambi quando ci si trova fuori da ricambi(bisognerebbe aggiungere un'altra chiave di ricerca composta es s1,s2,s3)*/
      var nodo_ricerca = {
        tipologie: ["tipologie", "marche", "modelli"],
        marche: ["marche", "modelli"],
        modelli: ["modelli"],
        ricambi: ["ricambi"]
      };
      //creare array di oggetti per configurare piu facilmente
      //tipologie,Termine Ricerca,Valore ricerca composto
      var s1 = this.getPosSelettore().id + "/" + value;
      var termine_ricerca = ["value", "value", "value", "s1"];
      var valore_ricerca = [value, value, value, s1];
      console.log(valore_ricerca);
      var posizione_selettore = this.getPosSelettore();
      var i = 0;
      for (var key in nodo_ricerca) {
        if (posizione_selettore.hook === key)
          for (var k in nodo_ricerca[key]) {
            var referenza = nodo_ricerca[key][k];
            let termine = termine_ricerca[i];
            let valore = valore_ricerca[i];
            //console.log(termine+ ' ' + valore +' ' +i)
            this.caricaChild(referenza, "ricambi", termine, valore).then(
              function(snapshot) {
                self.selettore.focus = 0;
                self.cambiaFocus(0, "selettore");
              },
              function(err) {
                if (err === "TIMEOUT") console.log("REJECT" + err);
                referenza.off();
                self.selettore.stato_caricamento = true;
              }
            );
          }
        i++;
      }
    },
    caricaStep(ricambio) {
      var self = this;
      return new Promise(function(resolve, reject) {
        self.ricambi = [];
        self
          .caricaChild(ricambio.hook, "ricambi", "category", ricambio.id)
          .then(
            function(snapshot) {
              //if (ricambio.parent === "modelli")
              //self.aggiungiDispositivo(ricambio);
              //PER L'INSERIMENTO CATEGORY E PARENT NON LI PRENDO DA STEP_SELEZIONATO
              //PERCHE' STEP_SELEZIONATO VIENE AGGIORNATO ANCHE QUANDO L'UTENTE
              //CLICCA SU UN RICAMBIO DEL SELETTORE, INVECE A ME SERVONO I DATI
              //RELATIVI ALLO STEP CORRENTE QUINDI LI AGGIORNO SOLO QUANDO VIENE INVOCATO CARICA_STEP
              self.CreaGanciNuovoElemento(ricambio);
              //self.selettore.step_selezionato = ricambio;
              self.selettore.path = [];
              self.selettore.path = self.cronologia_selettore;
              self.ricambi = self.unificaElementiArray(self.ricambi, "id");
              //self.applicaListino(self.regole);
              resolve();
            },
            function(err) {
              if (err === "TIMEOUT") {
                console.log("REJECT" + err);
                referenza.off();
                self.selettore.stato_caricamento = true;
              }
            }
          );
      });
    },
    caricaChild(sorgenteNodo, arrayDestin, termine, value) {
      //carico interno,poi esterno.Una volta caricato esterno se ok  resolve.
      //console.log('TERMINE:' + termine + ' VALUE: ' + value)
      var self = this;
      this.selettore.stato_caricamento = false;
      var refInterna = ref["Interno"].child(sorgenteNodo);
      var refEsterna = ref["Esterno"].child(sorgenteNodo);
      if (termine && value) {
        var refInterna = ref["Interno"]
          .child(sorgenteNodo)
          .orderByChild(termine)
          .startAt(value)
          .endAt(value + "\uf8ff");
        var refEsterna = ref["Esterno"]
          .child(sorgenteNodo)
          .orderByChild(termine)
          .startAt(value)
          .endAt(value + "\uf8ff");
      }
      return new Promise(function(resolve, reject) {
        refInterna.off(); // cancella listener precedenti.IMPORTANTE
        refInterna.on(
          "value",
          function(snapshot) {
            self[arrayDestin] = []; //AGGIUNTO DA BREENO PER PREVENIRE DOPPIONI
            //refInterna.off()
            self[arrayDestin] = [];
            if (snapshot.exists())
              snapshot.forEach(function(childSnapshot) {
                var childData = childSnapshot.val();

                self[arrayDestin].push(childData);
              });
            refEsterna.off(); // cancella listener precedenti.IMPORTANTE
            refEsterna.on(
              "value",
              function(snapshot) {
                //refEsterna.off()
                if (snapshot.exists())
                  snapshot.forEach(function(childSnapshot) {
                    var childData = childSnapshot.val();
                    self[arrayDestin].push(childData);
                    //merge degli elementi dell array

                    self[arrayDestin] = self.unificaElementiArray(
                      self[arrayDestin],
                      "id"
                    );
                  });
                resolve(snapshot);
                self.selettore.stato_caricamento = true;
              },
              function(errorObject) {
                console.log(
                  "Recupero dati nodo esterno fallito : " + errorObject.code
                );
              }
            );
          },
          function(errorObject) {
            console.log(
              "Recupero dati nodo interno fallito : " + errorObject.code
            );
          }
        );
      });
    },
    unificaElementiArray(array_orig, param) {
      return array_orig.filter(function(item, pos, array) {
        return (
          array
            .map(function(mapItem) {
              return mapItem[param];
            })
            .indexOf(item[param]) === pos
        );
      });
    },
    nelCarrello(obj) {
      if (this.items) {
        const mapIds = this.items.map(foo => foo["id"]);
        if (mapIds.includes(obj.id)) {
          return true;
        }
      }
      // return ids.includes(obj.id);*/
    },
    // QUI ANDRO' AD AGGIORNARE IL PROPS DEL PARENT CHE CONTIENE IL MIO COMPONENTE
    /*
    addToCart(elemento) {
      //if (elemento.parent === "ricambi")
      //this.costruttore.elementi=this.ricambi
    },
    removeFromCart() {},*/
    caricaBreadcrumb(step, index) {
      let self = this;
      this.chiediPrima().then(function() {
        self.caricaStep(step);
        self.cronologia_selettore = self.cronologia_selettore.slice(
          0,
          index + 1
        );
      });
    },
    setSelettore(percorso) {
      this.cronologia_selettore = [];
      this.pushSelettore(percorso);
    },
    pushSelettore(ricambio) {
      /* this.cronologia_selettore.push({
        hook: ricambio.hook,
        id: ricambio.id,
        value: ricambio.value,
        //AGGIUNTi DA BRENNO (SERVONO PERCHE' MI SERVONO PIU' INFO SULLOA CARTELLA CORRENTE)
        img_name: ricambio.img_name,
        fonte: ricambio.fonte,
        parent: ricambio.parent,
        category: ricambio.category
      });*/
      //strippo l oggetto della cronologia in modo da mantenere gli observer e non avere un oggetto troppo pesante
      //delete ricambio["img_name"]; //COMMENTATO DA BRENNO, IMG_NAME SERVE QUANDO PASSO LA COMPATIBILITA AL CARRELLO IN INSERIMENTO RICAMBI
      //delete ricambio["parent"];
      delete ricambio["s1"];
      //delete ricambio["hook"];
      //delete ricambio["fonte"];
      // delete ricambio["parent"];
      this.cronologia_selettore.push(ricambio);
    },
    /*
    getImageUrl(oggetto) {
      // AL POSTO DI QUESTA DOVREMMO METTREE IL COMPONENTE IMMAGINE. imageLoader.vue
      let estensione = oggetto.img_name.substr(oggetto.img_name.length - 4, 4);
      let img_name = oggetto.img_name.substr(0, oggetto.img_name.length - 4);
      if (oggetto.img_name !== null) {
        if (oggetto.fonte === "interno" && estensione === ".ext")
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            "%2F" +
            img_name +
            "?alt=media"
          );
        if (oggetto.fonte === "interno")
          return (
            ref.urlBucket +
            oggetto.parent +
            "%2F" +
            oggetto.img_name +
            "?alt=media"
          );
        if (oggetto.fonte === "esterno")
          return (
            ref.urlBucketEsterno +
            oggetto.parent +
            "%2F" +
            oggetto.img_name +
            "?alt=media"
          );
      }
    },*/
    getPosSelettore() {
      return this.cronologia_selettore[this.cronologia_selettore.length - 1];
    },
    //funzionalità utilizzo con tastiera
    freccieTastiera(selettore, e) {
      if (e.keyCode === 38) {
        this.cambiaFocus(-3, selettore);
      }
      if (e.keyCode === 40) {
        this.cambiaFocus(3, selettore);
      }
      if (e.keyCode === 39) {
        this.cambiaFocus(1, selettore);
      }
      if (e.keyCode === 37) {
        this.cambiaFocus(-1, selettore);
      }
    },
    cambiaSelezione(selettore, quale) {
      this[selettore].selezione = quale;
      this[selettore].focus = quale;
      this.cambiaFocus(0, selettore);
    },
    cambiaFocus(quanto, selettore) {
      let tabbables = document.getElementsByClassName(
        this[selettore].classe_focus
      );
      this[selettore].autofocus = true;
      let trim = 0; //NON SERVE PIU L'HO SETTATO A ZERO this[selettore].tasto_back ? 1 : 0;
      if (
        this[selettore].focus + quanto + trim <= tabbables.length - 1 &&
        this[selettore].focus + quanto + trim >= 0
      ) {
        this[selettore].focus += quanto;
        let pos = this[selettore].focus + trim;
        let self = this;
        Vue.nextTick(() => {
          tabbables[pos].focus();
        });
      }
    },
    keyDownQuadratino(e) {
      if ((e.keyCode >= 65 && e.keyCode < 90) || e.keyCode === 8) {
        cerca.focus();
      }
    },
    creaAlias(obj, value) {
      var self = this;
      var updates = {};
      var object = { value: value };
      updates[obj.id + "/" + "value"] = value;
      updates["alias/" + obj.id + "/value"] = value;
      if (obj.fonte === "interno") {
        console.log(updates);
        console.log(ref["Interno"].child("ricambi"));
        ref["Interno"].child(obj.parent).update(updates, function(error) {
          if (error) console.log("Errore creazione/aggiornamento aliasValue");
          else {
            //se salvataggio ok chiudo il concludo l'operazione di rinomina
            self.inEdit.title = "";
            console.log("Rinominato con successo ");
          }
        });
      } else console.log("Fonte esterna o non definita");
    }
  },
  beforeDestroy() {
    EventBus.$off("selettore");
  },
  mounted() {
    EventBus.$on("selettore", evento => {
      this.gestisciEventi(evento);
    });
    Vue.nextTick(() => {
      let self = this;
      window.addEventListener("resize", function() {
        self.verificaScroll("selettore");
      });
      this.ricambi = [];
      //HO SPOSTATO  LA FUNZIONE FUORI DA CARICA STEP PERCHE' IN REALTA'
      //IL SELETTORE SI TROVA NEL PRIMO STEP ANCOR PRIMA DI CARICARLO
      //HO VISTO CHE ANCHE PUSH_SELETTORE VIENE RICHIAMATO APPENA CLICCO SULLA CARTELLA E NON DOPO
      //AVER RISOLTO CARICA_STEP, INOLTRE PER LOGICA MI SERVE AVERE CRONOLOGIA.LENGHT GIA' AGGIORNATO
      //PRIMA DI RICHIAMARE CaricaGanci COSI' COME SUCCEDE PER GLI ALTRI STEP
      self.cronologia_selettore = [{ hook: "tipologie", value: "\uf015" }];
      this.caricaStep({ hook: "tipologie", value: "tipologie" }).then(
        function() {
          self.selezionato = "";
        }
      );
    });
  },
  watch: {
    ricambi() {
      this.verificaScroll("selettore");
      //serve per resettare l operazione di rinomina quadratino
      this.inEdit = { title: "", value: "" };
    },
    "regole.l_prezzo": {
      handler() {
        //alert('ciao')
        //Guardo in profondita le regole.Se avengono dei cambiamenti applico il listino.
        this.applicaListino(this.regole);
      },
      deep: true
    },
    "selettore.termine_ricerca"() {
      var self = this;
      if (this.selettore.delay !== "") clearTimeout(self.selettore.delay);
      if (self.selettore.termine_ricerca.trim())
        self.selettore.delay = setTimeout(function() {
          var value = self.selettore.termine_ricerca.toLowerCase();
          self.ricerca(value);
          self.filtraArray(value);
          self.selettore.delay = "";
        }, self.selettore.timeout);
      else this.caricaStep(this.getPosSelettore());
    },
    "selettore.posizioneSelettore"() {
      var self = this;
      //alert('ciao')
      //console.log(this.selettore.posizioneSelettore)
      this.caricaStep(this.selettore.posizioneSelettore).then(function() {
        // alert('ok')
        //self.selezionato = "";
        //self.cronologia_selettore = [{ hook: "tipologie", value: "\uf015" }];
      });
    },
    "selettore.positionToChildFolder"() {
      var self = this;
      this.ricambi = [];
      //caricaChild(sorgenteNodo, arrayDestin, termine, value)
      this.caricaChild(
        this.selettore.positionToChildFolder.parent,
        "ricambi",
        "category",
        this.selettore.positionToChildFolder.category
      ).then(
        function(snapshot) {
          self.selettore.focus = 0;
          self.cambiaFocus(0, "selettore");
        },
        function(err) {
          if (err === "TIMEOUT") console.log("REJECT" + err);
          referenza.off();
          self.selettore.stato_caricamento = true;
        }
      );
    },
    "selettore.resetSelettore"() {
      if (this.selettore.resetSelettore) {
        var self = this;
        this.ricambi = [];
        this.selettore.step_selezionato = "";
        this.cronologia_selettore = [{ hook: "tipologie", value: "\uf015" }];
        this.caricaStep({ hook: "tipologie", value: "tipologie" }).then(
          function() {
            //alert('ciao')
            self.selezionato = "";
            self.cronologia_selettore = [
              { hook: "tipologie", value: "\uf015" }
            ];
          }
        );
        this.selettore.resetSelettore = "resettato";
      }
    }
  }
};
</script>

<style scoped>
.opaco {
  opacity: 0.3;
}

.mantieni {
  opacity: 1 !important;
}

.giallo {
  background-color: #fbcf00 !important;
}

.tasto_aggiuntivo_quadratino {
  opacity: 0;
  position: absolute;
  top: -3px;
  right: -4px;
  z-index: 1;
  background-color: #fbcf00;
  width: 3.2vh;
  height: 3.2vh;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: solid 2px white;
  color: white;
  -webkit-box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.2);
  text-align: center;
  line-height: 2.8vh;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  z-index: 99999;
}

.form_cartella {
  background-color: white;
  color: white !important;
  z-index: 99999;
  border: solid 3px white !important;
}

.ultimo_inserito {
  border: solid 3px #a5dc86 !important;
}

.blink_me {
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    border: solid 3px #c2c3c4;
  }
}

.tasto_back:hover {
  color: grey;
}

.pieno {
  background-color: #f9f9f9 !important;
}

.tasto_back {
  font-size: 2.6vh;
  color: #e5e5e5;
  cursor: pointer;
}

.breadcrumb-item {
  cursor: pointer;

  background-color: #f9f9f9;
  margin-left: 1vh;
  padding-left: 2.5vh;
  padding-right: 2.5vh;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.breadcrumb-item:hover {
  color: grey;
}

.no-focus:focus {
  outline: none;
}

.pulsantini {
  position: absolute;
  right: 10px;
  color: #e5e5e5;
}

.pulsantini i {
  cursor: pointer;
}

.container {
  margin-top: 20px;
}

.cerca {
  background-color: #f9f9f9;
  border: 0;
  width: 80%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  height: 25px;
  color: black;
  text-align: center;
  font-style: normal !important;
  font-weight: normal !important;
  text-decoration: inherit;
  margin-left: 0.25em;
  vertical-align: middle;
  font-family: "Font Awesome 5 Free", "Arial" !important;
  /*font-weight: 900 !important;*/
}

.cerca:focus {
  outline: none;
}

/*COLORI PLACEHOLDER*/
.cerca::-webkit-input-placeholder {
  color: #c6c6c6;
}

.cerca::-moz-placeholder {
  color: #c6c6c6;
}

.cerca:-ms-input-placeholder {
  color: #c6c6c6;
}

.cerca:-moz-placeholder {
  color: #c6c6c6;
}

.breadcrumb {
  background-color: initial !important;
  font-size: 1.6vh;
  color: #c2c3c4;

  font-weight: 400;
  font-family: "Font Awesome 5 Free", "Arial" !important;
  margin: 0 !important;
  padding: 0 !important;
}

.breadcrumb > li + li:before {
  font-size: 1.6vh;
  color: white !important;
  content: "" !important;
  padding: 0px !important;
  margin: 0px !important;
  border: 0px !important;
}

.scroll-area-selettore {
  padding-left: 15px !important;
  padding-right: 15px !important;
  height: 100%;
}

.zona_scroll_selettore {
  position: relative;
  overflow-y: hidden !important;
  overflow-x: hidden;
  flex: 1; /*30px li lascio per div freccia scroll*/
  margin: 0px !important;
}

.sele {
  position: relative;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;

  /*  15px per titolo_ricambio  */
}

.sele:hover .tasto_aggiuntivo_quadratino {
  opacity: 1;
  /*  15px per titolo_ricambio  */
}

.bordo_animato {
  -moz-transition: border 0.3s ease;
  -o-transition: border 0.3s ease;
  -webkit-transition: border 0.3s ease;
  transition: border 0.3s ease;
}

.sele:focus-within {
  border: solid 3px #a0a0a0;
  outline: none;
  /*border-top:solid 3px  #f9f9f9;*/
}

.sele img {
  width: auto;
  height: 4.3vw;
  margin: 0;
}

.avatar {
  width: auto;
  height: 4.3vw;
  margin: 0;
}

.load_img {
  height: 4.3vw;
  margin: 0;
  font-size: 3vw;
  color: #afafaf;
  text-align: center;
}

.load_img :hover {
  color: #606060;
  cursor: pointer;
}

.label {
  -webkit-border-bottom-right-radius: 6px;
  -webkit-border-bottom-left-radius: 6px;
  -moz-border-radius-bottomright: 6px;
  -moz-border-radius-bottomleft: 6px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  margin: 0 auto;
  margin-top: -1px !important;
  width: 50px;
  bottom: 0px;
  background-color: #808080;
  color: white;
  font-size: 10px;
  text-align: center;
}

.label input {
  width: 60px;
  background: none;
  border: none;
  color: white;
}

.label input:focus {
  outline: none;
}

.titolo_selettore {
  font-size: 11px;
  color: #dedede;
  font-weight: 400;
  font-family: Arial;
  align-self: left;
}

.aggiunto {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  width: 5px;
  height: 5px;
  background-color: white;
  position: absolute;
  right: 6px;
  top: -5px;
}

.aggiunto img {
  position: absolute;
  top: 0;
  width: 20px;
  height: 20px;
}

.tag_prezzo {
  background-color: #afafaf;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;

  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.caption {
  text-align: center;
  line-height: 2.3vh;
  background-color: #f9f9f9;
  width: 100%;
  height: 2.5vh;
  position: relative;
  right: 0px;
  padding-top: 1px;
  display: block;
  color: #444444;
  font-size: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.tag_prezzo_list {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: orange;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.spinner_loading {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
}

.tasto_add_ricambio {
  line-height: 50px;
  font-size: 30px;
  color: #c2c3c4;
}

.titolo_ricambio {
  height: 15px;
  width: 120px;
  margin: 0 auto;
  font-size: 11px;
  text-align: center;
  text-transform: capitalize;
  color: #969696;
  margin-top: 0px !important;
}

.input_titolo_cartella {
  height: 15px;
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-transform: capitalize;
  color: black;
  margin-top: 0px !important;
  border: none;
}

.input_titolo_cartella:focus {
  outline: none;
}

.capitalized {
  text-transform: capitalize;
}

.list_selettore {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10vw, 1fr));
  list-style-type: none;
  padding: 0px;
  margin: 0px;
  grid-auto-rows: minmax(auto, 8.5vw);
  grid-gap: 10px;
}

.list_selettore li {
  background-color: white;
  border-radius: 10px;
  border: solid 3px #f9f9f9;
  font-size: 14px;
}

.freccia_scroll_selettore {
  text-align: center;
  height: 30px;
  font-size: 20px;
  color: #c4c4c4;
  margin: 0px;
  -moz-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.freccia_scroll_selettore i {
  -moz-transition: transform 0.5s ease-in;
  -o-transition: transform 0.5s ease-in;
  -webkit-transition: transform 0.5s ease-in;
  transition: transform 0.5s ease-in;
}

.freccia_scroll_carrello i {
  -moz-transition: transform 0.5s ease-in;
  -o-transition: transform 0.5s ease-in;
  -webkit-transition: transform 0.5s ease-in;
  transition: transform 0.5s ease-in;
}

.freccia_ruotata {
  -moz-transition: all 0.5s ease-in;
  -o-transition: all 0.5s ease-in;
  -webkit-transition: all 0.5s ease-in;
  transition: all 0.5s ease-in;
  -ms-transform: rotate(180deg); /* IE 9 */
  -webkit-transform: rotate(180deg); /* Safari */
  transform: rotate(180deg);
}

.scrolling {
  color: #606060 !important;
}

li > div {
  
}

/* SPINNER LOADER 2*/
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: #808080;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
